import EstimateAirQualityLegend from './EstimateAirQualityLegend'

export { default } from './EstimateAirQuality'

export const EstimateAirQualityMapConfig = {
  Content: EstimateAirQualityLegend,
}
